
import { defineComponent, PropType, ref, computed } from 'vue'
import { MemberProfile } from '@/modules/members'
import { useAclModule } from '@/modules/acl'
import useQuasar from 'quasar/src/composables/use-quasar.js';
import MembersEditMemberRoleDialog from '@/components/members/dialogs/edit-member-role.vue'

export default defineComponent({
    name: 'members-update-role',
    props: {
        member: {
            type: Object as PropType<MemberProfile>,
            required: true
        }
    },
    async setup (props) {
        const $q = useQuasar()
        const { getRoles } = useAclModule()
        const localModel = ref(props.member.permissions[0]?.role || '')

        await getRoles()
        const onValueUpdated = (newValue: string) => {
            localModel.value = newValue
        }

        // Temporary until we have role label in the backend
        const localModelName = computed(() => {
            return localModel.value === 'organization_main_user' ? 'Self-service user' : ''
        })

        function onChangeRole () {
            $q.dialog({
                component: MembersEditMemberRoleDialog,
                componentProps: {
                    organizationId: props.member.organizationId,
                    memberId: props.member.memberId,
                    role: localModel.value,
                    updateCallback: onValueUpdated
                }
            })
        }

        return {
            localModelName,
            onChangeRole
        }
    }
})
